import React from 'react'

import { Tooltip, Icon, Button, Dropdown } from 'antd'

import './toolbar.css';

class Toolbar extends React.Component {

    constructor (props){
        super();
        this.props = props;
    }

    renderItems = () => {

        return this.props.items.map( (item) => {
                const display = item.display === undefined ? true : item.display;

                if (!item.type || item.type === 'button') {
                    if ( display) {
                        return (
                            <Tooltip placement="top" title={item.title}>
                                <Button shape="circle" size="large" icon={item.icon} onClick={item.onClick}
                                        style={{margin: '0px 1px 0px 1px'}} disabled={item.disabled}
                                        htmlType={item.submit}/>
                            </Tooltip>
                        )
                    }
                }
                else if (item.type === 'dropdown-button'){
                    if ( display ){
                        return (
                            <Tooltip placement="top" title={item.title}>
                            <Dropdown overlay={item.menu} trigger={item.trigger}>
                                <Button shape="circle" size="large" icon={item.icon}
                                        style={{margin: '0px 1px 0px 1px'}} disabled={item.disabled}
                                />
                            </Dropdown>
                            </Tooltip>
                        )
                    }
                }
            }
        )
    }

    render() {
        return (
            <div id="toolbar">
                {this.renderItems()}
            </div>
        )
    }
}
export default Toolbar;
